<template>
  <v-card flat class="nre-bar">
    <!-- Select Site -->
    <v-app-bar elevation="1" class="px-13">
      <v-app-bar-title class="text-primary text-h6 font-weight-bold">
        Non-Routine Events
      </v-app-bar-title>
      <v-spacer />
      <v-row>
        <v-col>
          <SiteAutocomplete
            class="mt-6 mr-5"
            :items="sitesWithAnalyticsNonRoutineEvents"
            v-model="selectedSite"
            @update:modelValue="setDefaultSiteFromAnalyticsDomain"
          />
        </v-col>
        <v-col>
          <v-text-field
            class="mt-6 mr-5"
            v-model="searchTerm"
            hide-details
            prepend-inner-icon="mdi-magnify"
            single-line
            bg-color="white"
            variant="outlined"
            density="compact"
            :placeholder="placeholder"
            :clearable="true"
            @click:clear="handleSearchInput"
            @update:modelValue="handleSearchInput"
          />
        </v-col>
      </v-row>

      <template v-slot:append>
        <!-- Add Button -->
        <v-btn
          v-if="userCanUpdate || userCanCreate || userCanDelete"
          class="rounded-2 mr-3"
          color="primary"
          variant="flat"
          size="large"
          @click="handleAddAnalyticsNonRoutineEvent"
        >
          <div
            class="text-subtitle-2 text-white text-truncate font-weight-bold"
          >
            {{ $route.meta.buttonLabel }}
          </div>
        </v-btn>
      </template>
    </v-app-bar>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import SiteAutocomplete from '@/Core.UI.Domain/Components/SiteAutocomplete.vue';

export default {
  name: 'NonRoutineEventBar',

  components: { SiteAutocomplete },

  data() {
    return {
      searchTerm: '',
      selectedSite: null,
    };
  },

  async created() {
    await this.getSitesWithAnalyticsNonRoutineEvents();
    this.setDefaultSiteFromAnalyticsDomain(this.defaultSite);
  },

  beforeUnmount() {
    this.setAnalyticsNonRoutineEventsCurrentRoute('');
  },

  computed: {
    ...mapGetters({
      sitesWithAnalyticsNonRoutineEvents:
        'AnalyticsStore/AnalyticsNonRoutineEventsStore/sitesWithAnalyticsNonRoutineEvents',
      defaultSite: 'session/defaultSite',
    }),

    placeholder() {
      return this.$route.meta.placeholder || 'Search for a Non-Routine Event';
    },

    userCanCreate() {
      return this.$can('create', 'analytics');
    },
    userCanDelete() {
      return this.$can('delete', 'analytics');
    },
    userCanUpdate() {
      return this.$can('update', 'analytics');
    },
  },

  watch: {
    $route() {
      this.setDefaultSiteFromAnalyticsDomain(this.defaultSite);
      this.clearSearchTerm();
    },
  },

  methods: {
    ...mapActions({
      getSitesWithAnalyticsNonRoutineEvents:
        'AnalyticsStore/AnalyticsNonRoutineEventsStore/getSitesWithAnalyticsNonRoutineEvents',
      getAnalyticsNonRoutineEventsBySiteId:
        'AnalyticsStore/AnalyticsNonRoutineEventsStore/getAnalyticsNonRoutineEventsBySiteId',
      setAnalyticsNonRoutineEventsCurrentRoute:
        'AnalyticsStore/AnalyticsNonRoutineEventsStore/setAnalyticsNonRoutineEventsCurrentRoute',
      setDefaultSite: 'session/setDefaultSite',
    }),

    ...mapMutations({
      setAnalyticsNRESSearchTerm:
        'AnalyticsStore/AnalyticsNonRoutineEventsStore/ANALYTICS_NON_ROUTINE_EVENTS_SEARCH_TERM',
    }),

    setDefaultSiteFromAnalyticsDomain(selectedSite) {
      this.selectedSite =
        selectedSite || this.sitesWithAnalyticsNonRoutineEvents[0];
      this.setDefaultSite(this.selectedSite);

      this.getAnalyticsNonRoutineEventsBySiteId({
        selectedSite: this.selectedSite,
      }).then(() => {
        this.setAnalyticsNonRoutineEventsCurrentRoute(this.$route.name);
        this.clearSearchTerm();
      });
    },

    handleAddAnalyticsNonRoutineEvent() {
      // TODO: This is a temporary solution. This route will be replaced by the correct one, when the domain's refactor is done
      this.$router.push({
        name: 'NRECreate',
        params: { siteId: this.selectedSite.siteId || this.selectedSite.id },
      });
    },

    handleSearchInput(value) {
      if (typeof value === 'object') {
        this.setAnalyticsNRESSearchTerm('');
      } else {
        this.setAnalyticsNRESSearchTerm(value);
      }
    },

    clearSearchTerm() {
      this.searchTerm = '';
      this.setAnalyticsNRESSearchTerm('');
    },
  },
};
</script>
<style lang="scss" scoped>
.nre-bar {
  z-index: 1;
}

.v-input {
  max-width: 700px !important;
}

:deep(.v-field__input) {
  color: $primary !important;
}

:deep(.bg-white) {
  color: $primary !important;
}
</style>
